/*
  Smile quantity selector: keeps the visible .smile-quantity-input and the
  hidden form quantity in sync. Delegated on document so it works wherever
  the snippet is rendered, not only inside .luis-collection-slider-right.
*/
document.addEventListener("click", function (e) {
  var button = e.target.closest('.smile-quantity-selector button[name="plus"], .smile-quantity-selector button[name="minus"]');
  if (!button) return;

  var wrap = button.closest(".smile-quantity-selector-wrap");
  if (!wrap) return;

  var visible = wrap.querySelector(".smile-quantity-input");
  var hidden  = wrap.querySelector('input[name="quantity"]');
  if (!visible || !hidden) return;

  var current = parseInt(visible.value, 10);
  if (isNaN(current) || current < 1) current = 1;

  var next = button.name === "plus" ? current + 1 : Math.max(1, current - 1);

  visible.value = next;
  hidden.value  = next;

  /* Prevent this +/- click from bubbling up to anything that might
     treat it as an add-to-cart trigger (e.g. cart-drawer delegates,
     BOGOS box click). */
  e.preventDefault();
  e.stopPropagation();
});
